import PropTypes from "prop-types";
import { SubTicketPropsInterface } from "./SubTicketProp";

export const TicketPropsInterface = PropTypes.shape({
  id: PropTypes.number,
  created_at: PropTypes.string,
  created_by: PropTypes.number,
  updated_at: PropTypes.string,
  updated_by: PropTypes.number,
  deleted_at: PropTypes.oneOfType([PropTypes.string, PropTypes.oneOf([null])]),
  deleted_by: PropTypes.oneOfType([PropTypes.number, PropTypes.oneOf([null])]),
  project_name: PropTypes.string,
  code: PropTypes.string,
  sub_ticket_no: PropTypes.number,
  dealer_id: PropTypes.number,
  dealer_code: PropTypes.string,
  dealer_name: PropTypes.string,
  description: PropTypes.string,
  event_start_date: PropTypes.string,
  event_end_date: PropTypes.string,
  phase: PropTypes.string,
  status: PropTypes.string,
  previous_status: PropTypes.string,
  last_approver_sequence_no: PropTypes.number,
  next_approver_sequence_no: PropTypes.number,
  next_approver_level: PropTypes.string,
  next_approver_user_id: PropTypes.number,
  cancelled_by: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.oneOf([null]),
  ]),
  cancelled_level: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.oneOf([null]),
  ]),
  total_proposal_amount: PropTypes.number,
  total_claim_amount: PropTypes.number,
  fe_status: PropTypes.string,
  fe_previous_status: PropTypes.string,
  sub_tickets: PropTypes.arrayOf(SubTicketPropsInterface),
  activity_name: PropTypes.string,
  car_model_names: PropTypes.arrayOf(PropTypes.string),
  expected_customer_amount: PropTypes.number,
  expected_reserved_amount: PropTypes.number,
  actual_customer_amount: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.oneOf([null]),
  ]),
  actual_reserved_amount: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.oneOf([null]),
  ]),
});
